import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { SearchStateType, SearchStateTypeWithDates } from "../../../Orchestrator/Types/Index";

export class SwitchOriginDestinationAction extends BaseAction<void, SearchStateTypeWithDates> {

    override async run(): Promise<void | null> {
        try {
            const { search, isFromPopUp, searchPopup } = this.params!;
            if (search) {
                if (isFromPopUp) {
                    updateRecoilState("searchStatePopupAtom", {
                        ...searchPopup,
                        from: searchPopup?.to,
                        fromName: searchPopup?.toName,
                        fromGeoPosition: searchPopup?.toGeoPosition,
                        to: searchPopup?.from,
                        toName: searchPopup?.fromName,
                        toGeoPosition: searchPopup?.fromGeoPosition,
                    });
                }
                else {
                    updateRecoilState("searchStateAtom", {
                        ...search,
                        from: search.to,
                        fromName: search.toName,
                        fromGeoPosition: search?.toGeoPosition,
                        to: search.from,
                        toName: search.fromName,
                        toGeoPosition: search?.fromGeoPosition,
                    });
                }

            }
        } catch (error) {
            console.error("Error in SwitchOriginDestinationAction:", error);
        }
    }
}

// Create a singleton instance
export const switchOriginDestinationAction = new SwitchOriginDestinationAction(); 